import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export interface CookieConsentState {
  isConsentModalOpen: boolean;
  hasUserDecided: boolean;
  cookiesAccepted: boolean;
  consentTimestamp: string | null;
}

const initialState: CookieConsentState = {
  isConsentModalOpen: false,
  hasUserDecided: false,
  cookiesAccepted: false,
  consentTimestamp: null,
};

const cookieConsentPersistConfig = {
  key: "cookieConsent",
  storage,
  whitelist: ["hasUserDecided", "cookiesAccepted", "consentTimestamp"],
};

export const cookieConsentSlice = createSlice({
  name: "cookieConsent",
  initialState,
  reducers: {
    openConsentModal: (state) => {
      state.isConsentModalOpen = true;
    },
    closeConsentModal: (state) => {
      state.isConsentModalOpen = false;
    },
    acceptCookies: (state) => {
      state.cookiesAccepted = true;
      state.hasUserDecided = true;
      state.consentTimestamp = new Date().toISOString();
      state.isConsentModalOpen = false;
    },
    rejectCookies: (state) => {
      state.cookiesAccepted = false;
      state.hasUserDecided = true;
      state.consentTimestamp = new Date().toISOString();
      state.isConsentModalOpen = false;
    },
    resetConsent: (state) => {
      state.hasUserDecided = false;
      state.cookiesAccepted = false;
      state.consentTimestamp = null;
      state.isConsentModalOpen = false;
    },
  },
});

export const {
  openConsentModal,
  closeConsentModal,
  acceptCookies,
  rejectCookies,
  resetConsent,
} = cookieConsentSlice.actions;

export const cookieConsentReducer = persistReducer(
  cookieConsentPersistConfig,
  cookieConsentSlice.reducer
);

export default cookieConsentReducer; 